import React from "react";
import Modal from "react-bootstrap/Modal";
import Input from "./common/input";

const GrabberModal = ({
  show,
  data,
  handleChange,
  handleClick,
  handleClose
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="bg-success text-white">
        <h3>Save Grabber</h3>
      </Modal.Header>
      <form>
        <Modal.Body>
          <Input
            name="name"
            label="Name"
            placeholder="grabber"
            value={data}
            onChange={handleChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleClick}>
            Save
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default GrabberModal;
